module.exports = __webpack_public_path__ + "img/moviles-mobile.e3f63093.png";